import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function token() {
  return localStorage.getItem('neon_token') || localStorage.getItem('token') || '';
}

export default function InvoicePrintView() {
  const { id } = useParams();
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`/api/invoices/${id}/html?format=a4`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(async (res) => {
        if (!res.ok) throw new Error('No se pudo cargar la vista de impresión');
        return res.text();
      })
      .then((text) => {
        setHtml(text);
        setTimeout(() => window.print(), 250);
      })
      .catch((err) => setError(err.message));
  }, [id]);

  if (error) return <div style={{ padding: 24 }}>{error}</div>;
  if (!html) return <div style={{ padding: 24 }}>Preparando factura...</div>;
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
